import Lottie from "react-lottie";
import MapAnim from "../assets/lottie/map-1.json";
import MapAnim2 from "../assets/lottie/map2-lower.json";

function MapCardComponent() {
  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: MapAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultLottieOptions2 = {
    loop: true,
    autoplay: true,
    animationData: MapAnim2,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <div className="map-animated flex justify-center flex-col w-full h-full z-10 rounded-3xl overflow-hidden relative">
        <div className="map-animation2-container w-full h-full absolute left-0 hidden z-20">
          <Lottie options={defaultLottieOptions2} height="auto" />
        </div>
        <div className="map-animation-container w-full h-full scale-[3] absolute top-[350px] left-0">
          <Lottie options={defaultLottieOptions} height="auto" />
        </div>
      </div>
    </>
  );
}

export default MapCardComponent;
